import { EventActionType } from './event-action-type';

export interface UpdateEventRequestAction {
  eventKey: string;
  type: EventActionType.UpdateEventRequest;
}

export const updateEventRequest = (
  eventKey: string,
): UpdateEventRequestAction => ({
  eventKey,
  type: EventActionType.UpdateEventRequest,
});
